var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/content": "924f",
	"./assets/content.json": "924f",
	"./assets/data/2013": "32e1",
	"./assets/data/2013.json": "32e1",
	"./assets/data/2014": "ccd4",
	"./assets/data/2014.json": "ccd4",
	"./assets/data/2015": "0122",
	"./assets/data/2015.json": "0122",
	"./assets/data/2016": "8b26",
	"./assets/data/2016.json": "8b26",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_Bold.woff": "28d2",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_BoldItalic.woff": "a880",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_ExtraBold.woff": "205e",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_ExtraBoldItalic.woff": "0842",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_Heavy.woff": "fc65",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_HeavyItalic.woff": "2561",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_Italic.woff": "a724",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_LightItalic.woff": "a95d",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_Reg.woff": "b037",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_SemiBoldItalic.woff": "d22b",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_Semibold.woff": "97de",
	"./assets/fonts/adelle-cufonfonts-webfont/Adelle_light.woff": "7257",
	"./assets/fonts/adelle-cufonfonts-webfont/example.html": "6af4",
	"./assets/fonts/adelle-cufonfonts-webfont/style.css": "3711",
	"./assets/images/1.1.png": "55ed",
	"./assets/images/1.2.png": "1f3c",
	"./assets/images/1.3.png": "e844",
	"./assets/images/2.1.png": "bd34",
	"./assets/images/3.1.png": "5541",
	"./assets/images/3.2.png": "5cbf",
	"./assets/images/4.1.png": "dac2",
	"./assets/images/4.2.png": "981e",
	"./assets/images/4.3.png": "d30c",
	"./assets/images/black_and_yellow_smoke.png": "3560",
	"./assets/images/codeine.png": "9af1",
	"./assets/images/demerol.png": "59c4",
	"./assets/images/dilaudid.png": "70e2",
	"./assets/images/fentanyl.png": "9933",
	"./assets/images/hydrocodone.png": "7143",
	"./assets/images/methadone.png": "603a",
	"./assets/images/morphine.png": "28ce",
	"./assets/images/mscontin.png": "c323",
	"./assets/images/opioid_bottom_picture.png": "35dd",
	"./assets/images/opioid_pills.png": "5bc1",
	"./assets/images/opioid_pills_updated.png": "29d8",
	"./assets/images/oxycontin.png": "a838",
	"./assets/images/percocet.png": "f889",
	"./assets/logo.png": "cf05",
	"./assets/states": "e3ba",
	"./assets/states.json": "e3ba",
	"./components/HelloWorld": "fdab",
	"./components/HelloWorld.vue": "fdab",
	"./components/advert": "254a",
	"./components/advert.vue": "254a",
	"./components/cost_chart": "c48b",
	"./components/cost_chart.vue": "c48b",
	"./components/intro": "caf1",
	"./components/intro.vue": "caf1",
	"./components/opioid_list": "0161",
	"./components/opioid_list.vue": "0161",
	"./components/specialty_chart": "2af9",
	"./components/specialty_chart.vue": "2af9",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "41cb",
	"./router.js": "41cb",
	"./store": "c0d6",
	"./store.js": "c0d6",
	"./utils/specialty_utils": "bb91",
	"./utils/specialty_utils.js": "bb91",
	"./views/About": "f820",
	"./views/About.vue": "f820",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";